import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/react";
import Datepicker from "react-tailwindcss-datepicker";
import React from "react";
import { capitalizeFirstLetter } from "../components/utils/utils";
import { ChevronUpDownIcon, CheckIcon, InformationCircleIcon } from "@heroicons/react/24/outline";

const FilterSection = ({
    selectedDomain,
    domainList,
    dateValue,
    handleChange,
    onDateSelect,
    onDateFilterApply,
    title,
    isAuthor = false,
    authorName = ''
}) => (
    <div className="px-8 py-6 flex flex-wrap lg:flex-nowrap items-center md:justify-between border-b border-gray-200">
        <div className="min-w-full lg:min-w-0 flex-1 mb-4 lg:mb-0">
            {
                isAuthor ? (
                    <div className="min-w-full lg:min-w-0 flex-1 mb-4 lg:mb-0 flex items-center">
                        <img
                            alt=""
                            src="https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                            className="inline-block size-8 rounded-full mr-2"
                        />
                        <h2 className="text-lg font-bold text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight flex items-center">
                            {authorName} <InformationCircleIcon aria-hidden="true" className="size-6 ms-1" />
                        </h2>
                    </div>
                ) : null
            }

            <h2 className="text-lg font-bold text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
                {capitalizeFirstLetter(title) || ''}
            </h2>
        </div>
        <div className="flex flex-wrap lg:flex-nowrap w-full lg:w-auto flex-shrink-0 md:ml-4 md:mt-0 items-center">
            <div className="mr-0 lg:mr-4 w-full lg:w-40 mb-3 lg:mb-0">
                <Listbox value={domainList} onChange={handleChange}>
                    {/* <Label className="block text-sm/6 font-medium text-gray-900">Assigned to</Label> */}
                    <div className="relative">
                        <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-2.5 pl-4 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm/6">
                            <span className="block truncate text-gray-600">
                                {capitalizeFirstLetter(selectedDomain)}
                            </span>
                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                <ChevronUpDownIcon
                                    aria-hidden="true"
                                    className="size-5 text-gray-400"
                                />
                            </span>
                        </ListboxButton>

                        <ListboxOptions
                            transition
                            className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                        >
                            {domainList?.map((list, index) => (
                                <ListboxOption
                                    key={index}
                                    value={list}
                                    className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
                                >
                                    <span className="block truncate font-normal group-data-[selected]:font-semibold">
                                        {capitalizeFirstLetter(list.category)}
                                    </span>

                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                                        <CheckIcon
                                            aria-hidden="true"
                                            className="size-5"
                                        />
                                    </span>
                                </ListboxOption>
                            ))}
                        </ListboxOptions>
                    </div>
                </Listbox>
            </div>
            <div className="mr-0 lg:mr-4 w-full lg:w-64 mb-3 lg:mb-0">
                <div className="border border-gray-300 rounded-md shadow-sm">
                    <Datepicker
                        primaryColor={"red"}
                        value={dateValue}
                        onChange={(newValue) => onDateSelect(newValue)}
                        showShortcuts={true}
                        placeholder="Select date..."
                    />
                </div>
            </div>
            <div className="w-full lg:w-20">
                <button
                    type="button"
                    onClick={onDateFilterApply}
                    className="w-full items-center text-center rounded-full bg-red-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                >
                    {/* <AdjustmentsVerticalIcon aria-hidden="true" className="-ml-0.5 size-4" /> */}
                    Apply
                </button>
            </div>
        </div>
    </div>
);

export default FilterSection;
